var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, PropSync } from 'vue-property-decorator';
let UserSubjectSteps = class UserSubjectSteps extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    onToggle(index) {
        const progressParts = [
            this.internalProgress.substring(0, 1),
            this.internalProgress.substring(1, 2),
            this.internalProgress.substring(2, 3),
            this.internalProgress.substring(3, 4),
            this.internalProgress.substring(4, 5),
        ];
        progressParts[index] = progressParts[index] === '1'
            ? '0'
            : '1';
        this.internalProgress = progressParts.join('');
    }
};
__decorate([
    PropSync('progress', { required: true }),
    __metadata("design:type", String)
], UserSubjectSteps.prototype, "internalProgress", void 0);
UserSubjectSteps = __decorate([
    Component({})
], UserSubjectSteps);
export default UserSubjectSteps;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
